import { render, staticRenderFns } from "./NewUserDialog.vue?vue&type=template&id=a1f870ba&scoped=true&"
import script from "./NewUserDialog.vue?vue&type=script&lang=js&"
export * from "./NewUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f870ba",
  null
  
)

export default component.exports